import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { TooltipDirective } from "@progress/kendo-angular-tooltip";
import { Observable, Subscription } from 'rxjs';
import { Globals } from 'src/app/core/services/globals';
import {
  getACLicenseStatus,
  getCurrentTenant,
  getLTLicenseStatus,
  getLobbyLocationSelected,
  getLoggedInUserInfo
} from 'src/app/state';
import { State } from 'src/app/state/app.state';
import * as CoreActions from '../../../state/actions/core.actions';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  @ViewChild(TooltipDirective) public tooltipDir?: TooltipDirective;
  private subscriptions = new Subscription();
  isACLicenseEnabled$: Observable<boolean> = this.store.select(getACLicenseStatus);
  isLTLicenseEnabled$: Observable<boolean> = this.store.select(getLTLicenseStatus);

  public locationId = 0;
  public homeLocationId = 0;
  public lobbyLocationId = 0;
  public tenantId = 0;
  public userId: number = 0;
  constructor(public globals: Globals, private store: Store<State>) { }

  /**
   * FIXME Method too long
   */
  ngOnInit() {
    const uerLoggedSubscription = this.store.select(getLoggedInUserInfo)
      .subscribe((loggedInUserInfo) => {
        if (loggedInUserInfo != null) {
          this.homeLocationId = loggedInUserInfo.homeLocationId;
          this.userId = loggedInUserInfo.userId;
        }
      }
      );
    const userLocationSubscriptions = this.store.select(getLobbyLocationSelected).subscribe(
      (location) => {
        if (location.locationId != null && this.locationId !== location.locationId) {
          this.locationId = location.locationId as number;
          if (this.tenantId > 0) {
            this.store.dispatch(CoreActions.loadSystemConfigurations({
              payload: {
                locationId: this.locationId,
                tenantId: this.tenantId,
                userId: this.userId
              }
            }));
          }
        }
      }
    );
    const tenantSubscriptions = this.store.select(getCurrentTenant).subscribe(
      (tenantInfo) => {
        if (tenantInfo != null && this.tenantId !== tenantInfo.tenantID) {
          this.tenantId = tenantInfo.tenantID;
          if (this.locationId > 0) {
            this.store.dispatch(CoreActions.loadSystemConfigurations({
              payload: {
                locationId: this.locationId,
                tenantId: this.tenantId,
                userId: this.userId
              }
            }));
          }
          //passing home location if there are not branches
          else if (this.homeLocationId > 0) {
            this.store.dispatch(CoreActions.loadSystemConfigurations({
              payload: {
                locationId: this.homeLocationId,
                tenantId: this.tenantId,
                userId: this.userId
              }
            }));
          }

        }
      }
    );

    const locationCodeSubscription = this.store.select(getLobbyLocationSelected).subscribe((location) => {

      if (location.locationId !== undefined && location.locationId !== 0) {
        this.lobbyLocationId = location.locationId;

      }
    });
    this.subscriptions.add(uerLoggedSubscription);
    this.subscriptions.add(locationCodeSubscription);
    this.subscriptions.add(tenantSubscriptions);
    this.subscriptions.add(userLocationSubscriptions);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public showTooltip(e: MouseEvent): void {

    const element = e.target as HTMLElement;
    if (
      (element.nodeName == "TH" ||
        element.parentElement?.nodeName == "TH" ||
        element.nodeName == "TD") &&
      (element.offsetWidth < element.scrollWidth)
    ) {
      this.tooltipDir?.toggle(element);
    }
    else {
      this.tooltipDir?.hide();
    }
  }
}
